/* eslint-disable no-unused-vars*/
import {Config, CognitoIdentityCredentials} from 'aws-sdk'
import {CognitoUserPool, CognitoUser, AuthenticationDetails, CognitoUserAttribute} from 'amazon-cognito-identity-js'
const uuidv1 = require('uuid/v1');
import config from '../../config'

export default class CognitoAuth {
  constructor () {
    this.userSession = null;
  }

  configure (config) {
    if (typeof config !== 'object' || Array.isArray(config)) {
      throw new Error('[CognitoAuth error] valid option object required')
    }
    //console.log("in cognito, config is ", config);
    if (config.userPool) {
      this.userPool = config.userPool
    } else {
      this.userPool = new CognitoUserPool({
        UserPoolId: config.UserPoolId,
        ClientId: config.ClientId
      })
    }
    Config.region = config.region
    Config.credentials = new CognitoIdentityCredentials({
      IdentityPoolId: config.IdentityPoolId
    })
    this.options = config
  }

  isAuthenticated (cb) {
    let cognitoUser = this.getCurrentUser()
    console.log("coguser is ", cognitoUser)
    //console.log("idToken is ", this.getIdToken(cb))
    //console.log("jwtToken is ", cognitoUser.getIdToken().getJwtToken())
    if (cognitoUser != null) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          return cb(err, false)
        }
        return cb(null, true)
      })
    } else {
      cb(null, false)
    }
  }

  signup (email, pass, attributes, cb) {
    var username = attributes.username;

    var attributeList = [
      new CognitoUserAttribute({
        Name: 'email',
        Value: email
      })
    ]

    if (attributes.organization.length > 0) {
      attributeList.push(
        new CognitoUserAttribute({
          Name: 'custom:organization',
          Value: attributes.organization
        })
      )
      var id =  uuidv1();

      attributeList.push(
        new CognitoUserAttribute({
          Name: 'custom:organization_id',
          Value: id
        })
      )

      attributeList.push(
        new CognitoUserAttribute({
          Name: 'custom:method_of_boarding',
          Value: 'admin'
        })
      )
    }

    if (attributes.name.length > 0) {
      attributeList.push(
        new CognitoUserAttribute({
          Name: 'name',
          Value: attributes.name
        })
      )
    }
    this.userPool.signUp(username, pass, attributeList, null, cb)
  }

  confirmRegistration (username, code, cb) {
    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })
    cognitoUser.confirmRegistration(code, true, cb)
  }

  resendCode (username, code, cb) {
    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })
    cognitoUser.resendConfirmationCode(cb)
  }

  forgotPassword (username, cb) {
    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })

    cognitoUser.forgotPassword({
      onSuccess: (result) => {
        cb(null, result)
      },
      onFailure: function (err) {
        cb(err)
      },
      inputVerificationCode () {
        // cb(Error('Verification code not implemented.'))
        cb()
      }
    })
  }

  confirmPassword (username, code, password, cb) {
    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })

    cognitoUser.confirmPassword(code, password, {
      onSuccess: (result) => {
        cb(null, result)
      },
      onFailure: function (err) {
        cb(err)
      }
    })
  }

  changePassword (oldPassword, newPassword, cb) {
    let cognitoUser = this.getCurrentUser()

    // getSession() will load valid tokens cached in the local store so we can
    // authenticate and change the users password
    cognitoUser.getSession((err, session) => {
      if (err) {
        return cb(err, false)
      }
      cognitoUser.changePassword(oldPassword, newPassword, cb)
    })
  }

  signinInvitation (username, pass, newPass, cb) {
    let authenticationDetails = new AuthenticationDetails({
      Username: username,
      Password: pass
    })
    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        var logins = {}
        logins['cognito-idp.' + this.options.region + '.amazonaws.com/' + this.options.UserPoolId] = result.getIdToken().getJwtToken()

        Config.credentials = new CognitoIdentityCredentials({
          IdentityPoolId: this.options.UserPoolId,
          Logins: logins
        })
        this.onChange(true)
        cb(null, result)
      },

      newPasswordRequired: function(userAttributes, requiredAttributes) {
        cognitoUser.completeNewPasswordChallenge(newPass, userAttributes, this)
      },
      onFailure: (err) => {
        console.log("login in error ", err)
        cb(err)
      },
    })
  }

  signin (username, pass, cb) {
    let authenticationDetails = new AuthenticationDetails({
      Username: username,
      Password: pass
    })
    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.userPool
    })
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        var logins = {}
        logins['cognito-idp.' + this.options.region + '.amazonaws.com/' + this.options.UserPoolId] = result.getIdToken().getJwtToken()

        Config.credentials = new CognitoIdentityCredentials({
          IdentityPoolId: this.options.UserPoolId,
          Logins: logins
        })
        this.onChange(true)
        cb(null, result)
      },

      newPasswordRequired: function(userAttributes, requiredAttributes) {
        return this.$router.replace({path: '/invitation', query: {temp: pass, email: username}})
        //        cognitoUser.completeNewPasswordChallenge(newPassword, attributesData, this)
      },
      onFailure: (err) => {
        console.log("err signin ", err)
        cb(err)
      },
    })
  }

  logout () {
    this.getCurrentUser().signOut()
    this.onChange(false)
  }


  getIdToken (cb) {
    if (this.getCurrentUser() == null) {
      return cb(null, null)
    }
    this.getCurrentUser().getSession((err, session) => {
      if (err) return cb(err)
      if (session.isValid()) {
        //console.log("Jwt:", session.getIdToken().getJwtToken())
        return cb(null, session.getIdToken().getJwtToken())
      }
      cb(Error('Session is invalid'))
    })
  }

  getCurrentUser () {
    return this.userPool.getCurrentUser()
  }

  getUserAttributes(cb){
    let cognitoUser = this.getCurrentUser();
    if (cognitoUser != null) {
        cognitoUser.getSession(function (err, session) {
            cognitoUser.getUserAttributes(function(err, result) {
                if (err) {
                    console.log(err);
                    return;
                }
                var data = {};
                for (let i = 0; i < result.length; i++) {
                    data[result[i].getName()] = result[i].getValue();
                }
                cb(err, data)
            });

        });
    }

  }

  updateAttributes(attributes, cb) {
    var attributeList = []



    if (attributes.organization && attributes.organization.length > 0) {
      attributeList.push(
        new CognitoUserAttribute({
          Name: 'organization',
          Value: attributes.organization
        })
      )
    }
    if (attributes.name && attributes.name.length > 0) {
      attributeList.push(
        new CognitoUserAttribute({
          Name: 'name',
          Value: attributes.name
        })
      )
    }
    if (attributes.customer_id && attributes.customer_id.length > 0) {
      attributeList.push(
        new CognitoUserAttribute({
          Name: 'customer_id',
          Value: attributes.customer_id
        })
      )
    }

    let cognitoUser = this.getCurrentUser()

    // getSession() will load valid tokens cached in the local store so we can
    // authenticate and change the users password
    cognitoUser.getSession((err, session) => {
      if (err) {
        return cb(err, false)
      }
      cognitoUser.updateAtrributes(attributeList, cb);
    })

  }

  updateName(name, cb) {
    var attributeList = []
    attributeList.push(
      new CognitoUserAttribute({
        Name: 'name',
        Value: name
      })
    )


    let cognitoUser = this.getCurrentUser()

    cognitoUser.getSession((err, session) => {
      if (err) {
        return cb(err, false)
      }
      cognitoUser.updateAttributes(attributeList, cb);
    })
  }

  updateCustomerId(id, cb) {
    var attributeList = []
    attributeList.push(
      new CognitoUserAttribute({
        Name: 'custom:customer_id',
        Value: id
      })
    )
    let cognitoUser = this.getCurrentUser()

    cognitoUser.getSession((err, session) => {
      if (err) {
        return cb(err, false)
      }
      cognitoUser.updateAttributes(attributeList, cb);
    })
  }

  onChange () {}
}

CognitoAuth.install = function (Vue, options) {
  Object.defineProperty(Vue.prototype, '$cognitoAuth', {
    get () { return this.$root._cognitoAuth }
  })

  Vue.mixin({
    beforeCreate () {
      //console.log("options", this.$options)
      if (this.$options.cognitoAuth) {
        this._cognitoAuth = this.$options.cognitoAuth
        //this._cognitoAuth.configure(options)
        this._cognitoAuth.configure(config)
      }
    }
  })
}
